import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chief-editor',
  templateUrl: './chief-editor.component.html',
  styleUrls: ['./chief-editor.component.scss']
})
export class ChiefEditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
